document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("yf-show-overlay");
  var video = document.getElementById("yf-show-youtube");
  var closeBtn = document.getElementById("yf-show-close");
  var overlay = document.getElementById("yf-show-overlay");
  var soundBtn = document.getElementById("yf-sound-button");

  var mutedVideoUrl = "https://www.youtube.com/embed/qyR3dWRnQms?autoplay=1&mute=1&rel=0&playsinline=1";
  var soundVideoUrl = "https://www.youtube.com/embed/qyR3dWRnQms?autoplay=1&mute=0&rel=0&playsinline=1";

  function getTodayDateKey() {
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var day = String(today.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  function safeGet(storageType, key) {
    try {
      return storageType.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(storageType, key, value) {
    try {
      storageType.setItem(key, value);
    } catch (e) {}
  }

  var todayKey = getTodayDateKey();
  var lastShownDate = safeGet(localStorage, "yfShowOutNowPopupLastShownDate");
  var shownThisSession = safeGet(sessionStorage, "yfShowOutNowPopupShownThisSession");

  if (!shownThisSession && lastShownDate !== todayKey) {
    var showTrailerPopup = function () {
      if (popup && video) {
        video.src = mutedVideoUrl;
        popup.style.display = "flex";
        safeSet(sessionStorage, "yfShowOutNowPopupShownThisSession", "true");
        safeSet(localStorage, "yfShowOutNowPopupLastShownDate", todayKey);
      }
    };

    // Performance: a large auto-opening overlay can become the page's LCP several
    // seconds after the real content is already visible. Wait until the visitor has
    // interacted with the page, then show the same once-per-day promo shortly after.
    // This preserves the campaign without contaminating Core Web Vitals.
    var interactionScheduled = false;
    var scheduleAfterInteraction = function () {
      if (interactionScheduled) return;
      interactionScheduled = true;
      window.setTimeout(showTrailerPopup, 2500);
      document.removeEventListener("pointerdown", scheduleAfterInteraction, true);
      document.removeEventListener("keydown", scheduleAfterInteraction, true);
      document.removeEventListener("touchstart", scheduleAfterInteraction, true);
    };
    document.addEventListener("pointerdown", scheduleAfterInteraction, { capture: true, passive: true });
    document.addEventListener("keydown", scheduleAfterInteraction, { capture: true });
    document.addEventListener("touchstart", scheduleAfterInteraction, { capture: true, passive: true });
  }

  if (soundBtn) {
    soundBtn.addEventListener("click", function () {
      if (video) {
        video.src = soundVideoUrl;
      }

      soundBtn.innerHTML = "🔊 Sound On";
      soundBtn.style.opacity = "0.75";
    });
  }

  function closeYFShowPopup() {
    if (popup) popup.style.display = "none";
    if (video) video.src = "";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeYFShowPopup);
  }

  if (overlay) {
    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) {
        closeYFShowPopup();
      }
    });
  }
});
